import axios from "axios";

import router from "@/router";

const token = localStorage.getItem("token");

axios.defaults.baseURL = `${import.meta.env.VITE_API_URL}`;
axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;
axios.defaults.timeout = 10000;

axios.interceptors.response.use((config) => {
  config.params = {
    auth: token,
  };

  config.headers = {
    Authorization: `Bearer ${token}`,
  };

  return config;
});

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // console.log(error);
    
    if (error.response)
      switch (error.response.status) {
        case 401:
          console.log("401");
          //router.push({ name: "auth-login" });
          break;
        case 404:
          console.log("404");
          break;
        case 500:
          console.log("500");
          break;
        default:
          break;
      }

    return Promise.reject(error);
  }
);

export default axios;
